<template>
  <loading v-if="!batteryIsLoaded"></loading>
  <not-found v-else-if="!batteryItem"></not-found>
  <div v-else>
    <h5 v-if="!noHeader && !forPdf">
      <router-link :to="`/batteries/${batteryItem.id}`">
        {{ batteryItem.name }}
      </router-link>
    </h5>
    <div v-if="!forPdf">
      <span class="u-color-muted"> {{ $t("batteries.userInfo") }}: </span>
      <span>{{ batteryItem.userInfo.fullname }}</span>
      <chip :variant="getBatteryType(batteryItem.type).variant">
        {{ $t(getBatteryType(batteryItem.type).name) }}
      </chip>
    </div>
    <div class="row s-batteries__drawer-detail">
      <div
        class="es-xs-12 u-margin-top-xsmall u-padding-top-xsmall u-radius-g"
        :class="forPdf ? 'es-md-6' : 'es-md-6'"
        v-for="(feature, i) in batteryFeatures"
        :key="i"
      >
        <h6 class="u-color-primary">{{ feature.localesInfo[$i18n.locale] }}</h6>
        <ul class="c-list u-margin-top-small">
          <li
            class="c-list__item u-display-flex u-align-items-center u-justify-content-space-between"
            v-for="(option, j) in feature.options"
            :key="i + '-' + j"
          >
            <span> {{ option.localesInfo[$i18n.locale] }}</span>
            <span>{{ option.value }} {{ option.suffix }} </span>
          </li>
        </ul>
        <div v-if="i === 1">
          <h6 class="u-margin-top-xsmall u-margin-bottom-small u-color-primary">
            {{ $t("batteryDetail.otherFeatures") }}
          </h6>
          <ul class="c-list">
            <li class="c-list__item">
              <span> {{ $t("batteryDetail.tubeLiquidVelocity") }}</span>
              <span>{{
                batteryItem.batteryResultInfo?.tubeLiquidVelocity
              }}</span>
            </li>
            <li class="c-list__item">
              <span> {{ $t("batteryDetail.tubeVaporVelocity") }}</span>
              <span>{{
                batteryItem.batteryResultInfo?.tubeVaporVelocity
              }}</span>
            </li>
            <li class="c-list__item">
              <span> {{ $t("batteryDetail.inletEnthalpy") }}</span>
              <span>{{ batteryItem.batteryResultInfo?.inletEnthalpy }}</span>
            </li>
            <li class="c-list__item">
              <span> {{ $t("batteryDetail.outletEnthalpy") }}</span>
              <span>{{ batteryItem.batteryResultInfo?.outletEnthalpy }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="es-xs-12 es-md-6">
        <div class="u-margin-top-xsmall">
          <img src="@/assets/images/coil.jpg" width="100%" alt="" />
        </div>
      </div>
      <div
        class="es-xs-12 es-md-12 u-margin-top-xsmall u-padding-xsmall"
        v-for="(feature, i) in batteryResultFeatures"
        :key="i"
      >
        <h6 class="u-color-primary">{{ feature.localesInfo[$i18n.locale] }}</h6>
        <div class="u-display-flex u-width-100% row-gap-10">
          <ul class="c-list u-margin-top-small u-flex-1">
            <li
              class="c-list__item u-display-flex u-align-items-center u-justify-content-space-between"
              v-for="(option, j) in feature.options.slice(0, 6)"
              :key="i + '-' + j"
            >
              <span> {{ option.localesInfo[$i18n.locale] }}</span>
              <span>{{ option.value }} {{ option.suffix }} </span>
            </li>
          </ul>
          <ul class="c-list u-margin-top-small u-flex-1">
            <li
              class="c-list__item u-display-flex u-align-items-center u-justify-content-space-between"
              v-for="(option, j) in feature.options.slice(6, 13)"
              :key="i + '-' + j"
            >
              <span> {{ option.localesInfo[$i18n.locale] }}</span>
              <span>{{ option.value }} {{ option.suffix }} </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBatteryType } from "@/helpers/Battery/getBatteryType";
import batteryMixin from "@/mixins/batteryMixin";
import Chip from "../Base/Chip.vue";
import NotFound from "../Base/NotFound.vue";
export default {
  mixins: [batteryMixin],
  components: {
    Chip,
    NotFound,
  },
  data() {
    return {
      batteryItem: null,
    };
  },
  props: {
    noHeader: {
      default: false,
      type: Boolean,
    },
    batteryId: {
      default: 0,
    },
    battery: {
      default: null,
    },
    force: {
      default: true,
    },
    forPdf: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    getBatteryType,
  },
};
</script>

<style></style>
